import HTTP from '@/api/HTTP';
import transform from '@/services/logistique/tourneeFaceSemaine/tourneeModeleServerTableDataTransformer';

const URL_BASE = 'gescom/TourneeFaceSemaine/';

export async function getAll(serverTabledata) {
  const inputServer = transform(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function affecter(params) {
  const response = await HTTP.post(URL_BASE + 'AffecterAsync', params);
  return response;
}

export async function affecterTourneeAffichage(params) {
  const response = await HTTP.post(URL_BASE + 'affecterTourneeAffichageAsync', params);
  return response;
}

export async function affecterTourneeAffichageFictiveAsync(params) {
  const response = await HTTP.post(URL_BASE + 'AffecterTourneeAffichageFictiveAsync', params);
  return response;
}

export async function generation(params) {
  const response = await HTTP.post(URL_BASE + 'GenerationAsync', params);
  return response;
}

export async function getChargeTravail(params) {
  const response = await HTTP.post(URL_BASE + 'PGetChargeTravailAsync', params);
  return response;
}

export async function affecterActionAffichageAsync(params) {
  const response = await HTTP.post(URL_BASE + 'AffecterActionAffichageAsync', params);
  return response;
}

export async function affecterInstructionPoseAsync(params) {
  const response = await HTTP.post(URL_BASE + 'AffecterInstructionPoseAsync', params);
  return response;
}

export async function affecterLaisserEnPlaceAsync(param) {
  const response = await HTTP.post(URL_BASE + 'AffecterLaisserEnPlaceAsync', param);
  return response;
}

export async function get(id) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: id } });
  return response;
}

export async function commenterTfsAsync(param) {
  const response = await HTTP.post(URL_BASE + 'CommenterTfsAsync', param);
  return response;
}

export async function updateAffecterTfsToListAffichageAllAsync(param) {
  const response = await HTTP.put(URL_BASE + 'UpdateAffecterTfsToListAffichageAllAsync', param);
  return response;
}
